import { supabase } from '../lib/supabase';
class ProjectService {
    async fetchProjects() {
        try {
            const { data, error } = await supabase
                .from('projects')
                .select('*')
                .order('created_at', { ascending: false });
            if (error) {
                console.error('Error fetching projects:', error);
                return [];
            }
            return data || [];
        }
        catch (error) {
            console.error('Error fetching projects:', error);
            return [];
        }
    }
    async createProject(project) {
        try {
            const { data: { user } } = await supabase.auth.getUser();
            const { data, error } = await supabase
                .from('projects')
                .insert([{
                    ...project,
                    created_by: user?.id
                }])
                .select()
                .single();
            if (error) {
                console.error('Error creating project:', error);
                return null;
            }
            return data;
        }
        catch (error) {
            console.error('Error creating project:', error);
            return null;
        }
    }
    async updateProject(id, updates) {
        try {
            const { data, error } = await supabase
                .from('projects')
                .update({
                ...updates,
                updated_at: new Date().toISOString()
            })
                .eq('id', id)
                .select()
                .single();
            if (error) {
                console.error('Error updating project:', error);
                return null;
            }
            return data;
        }
        catch (error) {
            console.error('Error updating project:', error);
            return null;
        }
    }
    async deleteProject(id) {
        try {
            const { error } = await supabase
                .from('projects')
                .delete()
                .eq('id', id);
            if (error) {
                console.error('Error deleting project:', error);
                return false;
            }
            return true;
        }
        catch (error) {
            console.error('Error deleting project:', error);
            return false;
        }
    }
}
export const projectService = new ProjectService();
